import { Row, Column } from '@simplywallst/ui-core';
import { SWS_IMAGES, SWS_LEGACY_HOST } from '@/constants';
import DeferRenderUntilIntersecting from '@components/DeferRenderUntilIntersecting';
import { useTheme } from '@simplywallst/ui-core';
import { FlagContainer, MapContainer } from './styled';

interface LocationProps {
  companyId: string;
  address: string;
  city: string;
  zipCode: string;
  country: string;
  countryIso: string;
  address2: string;
  state: string;
  companyName: string;
  skipDefer: boolean;
}

const defaultProps = {
  companyId: '',
  address: '',
  city: '',
  zipCode: '',
  country: '',
  countryIso: '',
  address2: '',
  state: '',
};

const Location = ({
  companyId,
  address,
  city,
  zipCode,
  country,
  countryIso,
  address2,
  companyName,
  state,
  skipDefer,
}: LocationProps) => {
  const theme = useTheme();
  return (
    <Row>
      <Column col={6}>
        <FlagContainer>
          <DeferRenderUntilIntersecting skipDefer={skipDefer}>
            {() => (
              <img
                alt={`${countryIso} flag`}
                src={`${SWS_LEGACY_HOST}/build/images/country/${countryIso}.png`}
              />
            )}
          </DeferRenderUntilIntersecting>
        </FlagContainer>
      </Column>
      <Column col={6}>
        <ul itemProp="address">
          {companyName && (
            <li>
              <strong>{companyName}</strong>
            </li>
          )}
          {address && <li>{address}</li>}
          {address2 && <li>{address2}</li>}
          {city && <li>{city}</li>}
          {state && <li>{state}</li>}
          {zipCode && <li>{zipCode}</li>}
          {country && <li>{country}</li>}
        </ul>
      </Column>
      <Column col={12}>
        <hr />
        <MapContainer>
          <DeferRenderUntilIntersecting skipDefer={skipDefer}>
            {() => (
              <img
                alt={`${companyName} headquarters, provided by Google`}
                src={`${SWS_IMAGES}/company/${companyId}/map?theme=${theme.appTheme}`}
              />
            )}
          </DeferRenderUntilIntersecting>
        </MapContainer>
      </Column>
    </Row>
  );
};

Location.defaultProps = defaultProps;

export default Location;
